<app-header-slim></app-header-slim>
<main>
  <router-outlet></router-outlet>
  <app-modal-container></app-modal-container>
</main>
<app-footer></app-footer>
